import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient'

export default {
	async [actionTypes.PEDIDO.DOCUMENTOS.BUSCAR_SIGNATARIOS](context, idDocumento) {
		const { data } = await api.signatarioPedidoApiClient.buscarSignatariosDocumento(idDocumento)
		return data
	},
	async [actionTypes.PEDIDO.DOCUMENTOS.CONVIDAR_SIGNATARIOS](context, { idDocumento, emailsSignatarios }) {
		return await api.signatarioPedidoApiClient.convidarSignatariosProcessoDigital(idDocumento, emailsSignatarios)
	},

	async [actionTypes.PEDIDO.DOCUMENTOS.SIGNATARIOS.EXCLUIR](context, { idDocumento, emailsSignatarios }) {
		await api.signatarioPedidoApiClient.excluirSignatariosProcessoDigital(idDocumento, emailsSignatarios)
	},

	async [actionTypes.PEDIDO.DOCUMENTOS.BUSCAR_ASSINATURAS_NAO_CONCLUIDAS](context, idPedido) {
		const { data } = await api.signatarioPedidoApiClient.buscarAssinaturasNaoConluidasDocumentoProcessoDigital(
			idPedido,
		)
		return data
	},
}
